const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': '안녕',
    'Ref: Page content body': '도착 및 출발시 QR 코드 버스를 스캔하는 것을 기억하십시오.',
  },
};
export default labels;
